import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles({
  spacer: {
    flex: 1,
  },
})
export const userStatusChoises = [
  { id: 'disabled', name: 'disabled' },
  { id: 'active', name: 'active' },
]
